import {createSelector} from '@reduxjs/toolkit';
import {State} from '../store';
import {type} from './state';

const preferencesState = (state: State) => state[type];

export const getMarketingEmailStatus = createSelector(
    preferencesState,
    state => state.marketingEmailStatus
);

export const getPushNotificationsStatus = createSelector(
    preferencesState,
    state => state.pushNotificationsStatus
);

export const getIsFetching = createSelector(
    preferencesState,
    state => state.isFetching
);

export const getIsSaving = createSelector(
    preferencesState,
    state => state.isSaving
);

export const getErrorMessage = createSelector(
    preferencesState,
    state => state.errorMessage
);
